import Vue from 'vue'
import Vuex from 'vuex'
import account from 'Store/Account'
import balance from 'Store/Balance'
import billing from 'Store/Billing'
import categoryDirectory from 'Store/CategoryDirectory'
import categoryQuotation from 'Store/CategoryQuotation'
import checkout from 'Store/Checkout'
import companyAccount from 'Store/CompanyAccount'
import companyChat from 'Store/CompanyChat'
import companyProfile from 'Store/CompanyProfile'
import creditCard from 'Store/CreditCard'
import location from 'Store/Location'
import navigation from 'Store/Navigation'
import payment from 'Store/Payment'
import quoteNegotiation from 'Store/QuoteNegotiation'
import quoteOpportunity from 'Store/QuoteOpportunity'
import quoteReadOnly from 'Store/QuoteReadOnly'
import quoteRequest from 'Store/QuoteRequest'
import signup from 'Store/Signup'
import statement from 'Store/Statement'
import support from 'Store/Support'
import userAccount from 'Store/UserAccount'
import userChat from 'Store/UserChat'
import opportunityDetails from 'Store/QuoteOpportunity/opportunityDetails'
import spreadsheet from 'Store/QuoteRequest/spreadsheet'
import research from 'Store/Research'
import upgradableSubscription from 'Store/UpgradableSubscription'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    account,
    balance,
    billing,
    categoryDirectory,
    categoryQuotation,
    checkout,
    companyAccount,
    companyChat,
    companyProfile,
    creditCard,
    location,
    navigation,
    payment,
    quoteNegotiation,
    quoteOpportunity,
    quoteReadOnly,
    opportunityDetails,
    quoteRequest,
    signup,
    statement,
    support,
    userAccount,
    userChat,
    spreadsheet,
    research,
    upgradableSubscription
  }
})

